import React from 'react';
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom';
import { AuthProvider } from './context/AuthContext';
import { DevisProvider } from './context/DevisContext';
import Login from './components/Login';
import Dashboard from './components/Dashboard';
import DevisList from './components/DevisList';
import UsersList from './components/UsersList';
import Profile from './components/Profile';
import PrivateRoute from './components/PrivateRoute';
import './App.css';

function App() {
  return (
    <AuthProvider>
      <DevisProvider>
        <Router>
          <div className="App">
            <Switch>
              <Route exact path="/login" component={Login} />
              <PrivateRoute exact path="/" component={Dashboard} />
              <PrivateRoute exact path="/devis" component={DevisList} />
              <PrivateRoute exact path="/users" component={UsersList} />
              <PrivateRoute exact path="/profile" component={Profile} />
              <Redirect to="/" />
            </Switch>
          </div>
        </Router>
      </DevisProvider>
    </AuthProvider>
  );
}

export default App;

